import { render, staticRenderFns } from "./WorkerThanks.vue?vue&type=template&id=e2f79206&"
import script from "./WorkerThanks.vue?vue&type=script&lang=js&"
export * from "./WorkerThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports